import React, { Component } from "react";
import { observer } from "mobx-react";
import Tab from "../tap";
import Title from "../GoBackShop";
import Left from "../../static/images/left.png";
import user from "../../static/images/user.png";
import home from "../../store/index";
import Loading from "../Loading/index";
import "./index.css";
import { ListView } from "antd-mobile";
import { PeoplefindAllPageable } from "../../static/js/http";
@observer
class Person extends Component {
  constructor() {
    super();
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2, // rowHasChanged(prevRowData, nextRowData); 用其进行数据变更的比较
    });

    this.state = {
      dataSource,
      datas: [],
      size: 20,
      page: 0,
      hasMore: true,
      refreshing: true,
      isLoading: true,
      dataArr: [],
      showId: "0",
      totalElements: 0,
    };
  }
  componentDidMount() {
    this.getListData();
  }
  getListData() {
    let params = {
      size: this.state.size,
      page: this.state.page,
    };
    PeoplefindAllPageable(params)
      .then((res) => {
        if (res.msg === "success") {
          let data = res.data;
          if (data.length !== 0) {
            let newDat =
              data &&
              data.pageData &&
              data.pageData.filter((item) => item.storeGroupEntity.isEnabled);
            this.setState({
              ...this.state,
              dataSource: this.state.dataSource.cloneWithRows(newDat),
              refreshing: false,
              isLoading: false,
              dataArr: newDat, // 保存新数据进state
              totalElements: data.totalElements,
              totalPages: data.totalPages,
              page: this.state.page + 1,
            });
          }
        }
      })
      .catch((err) => {});
  }

  getData() {
    //获取数据
    let params = {
      size: this.state.size,
      page: this.state.page,
    };
    this.setState({
      refreshing: true,
      isLoading: true,
      hasMore: false,
    });
    PeoplefindAllPageable(params)
      .then((res) => {
        if (res.msg === "success") {
          let newDat =
            res.data &&
            res.data.pageData &&
            res.data.pageData.filter((item) => item.storeGroupEntity.isEnabled);

          let dataArr = this.state.dataArr.concat(newDat);
          this.setState({
            ...this.state,
            dataSource: this.state.dataSource.cloneWithRows(dataArr), // 数据源中的数据本身是不可修改的,要更新datasource中的数据，请（每次都重新）调用cloneWithRows方法
            refreshing: false,
            isLoading: false,
            dataArr: dataArr, // 保存新数据进state
            totalElements: res.data.totalElements,
            totalPages: res.data.totalPages,
            page: this.state.page + 1,
          });
          setTimeout(() => {
            home.isLoading = false;
          }, 1000);
        }
      })
      .catch((err) => {});
  }

  // 滑动到底部时加载更多
  onEndReached = (event) => {
    if (this.state.page + 1 <= this.state.totalPages) {
      if (this.state.totalElements - this.state.dataArr.length >= 1) {
        setTimeout(() => {
          this.setState({
            refreshing: true,
            isLoading: true,
          });
          this.getData();
        }, 1000);
      } else {
        this.setState({
          refreshing: true,
          isLoading: false,
          hasMore: false,
        });
      }
    } else {
      this.setState({
        refreshing: true,
        isLoading: false,
        hasMore: false,
      });
    }
  };

  changeShowId(rowID) {
    this.setState({ showId: rowID, dataSource: this.state.dataArr });
  }
  goDetail(rowData) {
    home.peopleDetail = rowData && rowData.storeGroupEntity;
    this.props.history.push("/persondetail");
    home.personOneId = 25;
  }
  bottomshow() {
    if (this.state.isLoading) {
      return "加载中...";
    } else if (!this.state.isLoading) {
      if (this.state.page + 1 >= this.state.totalPages) {
        return "暂无更多数据";
      } else {
        return "加载完成";
      }
    }
  }
  render() {
    const row = (rowData, sectionID, rowID) => {
      // 这里rowData,就是上面方法cloneWithRows的数组遍历的单条数据了，直接用就行
      return (
        <div
          className="person_list_item"
          onClick={() => {
            this.goDetail(rowData);
          }}
        >
          <div className="person_pic">
            <img
              src={
                rowData.storeGroupEntity.icon
                  ? rowData.storeGroupEntity.icon
                  : user
              }
              alt=""
            />
          </div>
          <div className="per_name">
            <span>{rowData.storeGroupEntity.name}</span>
            <i>
              <img src={Left} alt="" />
            </i>
          </div>
        </div>
      );
    };

    return (
      <div className="Person">
        <Title />
        <div className="person_list">
          {this.state.dataArr.length === 0 ? (
            <div className="person_list_item">
              <div className="person_pic">
                <img src={user} alt="" />
              </div>
              <div className="per_name">
                <span>暂无解忧人</span>
                <i>
                  <img src={Left} alt="" />
                </i>
              </div>
            </div>
          ) : (
            ""
          )}
          {this.state.dataArr.length !== 0 ? (
            <ListView
              ref={(el) => (this.lvPeople = el)}
              dataSource={this.state.dataSource}
              initialListSize={50}
              renderRow={row}
              onEndReachedThreshold={100}
              onEndReached={this.onEndReached.bind(this)}
              pageSize={1}
              style={{
                height: "100%",
                overflow: "auto",
              }}
            />
          ) : (
            ""
          )}
        </div>
        {this.state.dataArr.length !== 0 ? (
          <div className="people_infor">
            <p>职场解忧人阵容:</p>
            <p>
              来自联想全球学习与发展团队的同事和各个业务的HRP同事，有职业生涯规划师还有乐成长合伙人。
            </p>
          </div>
        ) : (
          ""
        )}
        <Tab />
        {home.isLoading ? <Loading /> : ""}
      </div>
    );
  }
}
export default Person;
